import type {
  Technician,
  ServiceOrder,
  RouteOptimization,
  TechnicianLocation,
  VanPart,
  ServiceHistoryItem,
  PreventiveMaintenance,
  SLAPolicy,
} from './types';

export const sampleTechnicians: Technician[] = [
  { id: '1', name: 'Marcus Vance', email: 'marcus.v@helios.local', phone: '+1-555-0322', skills: ['Fiber Optics', 'Rack Mount'], status: 'AVAILABLE', current_city: 'Chicago, IL', assigned_jobs: 2 },
  { id: '2', name: 'Elena Rostova', email: 'elena.r@helios.local', phone: '+1-555-0344', skills: ['HVAC', 'Calibration'], status: 'ON_SITE', current_city: 'Austin, TX', assigned_jobs: 1 },
];

export const sampleServiceOrders: ServiceOrder[] = [
  { id: '1', order_number: 'SVC-2026-0089', customer_name: 'NexGen Data Labs', address: '772 North Wacker Dr, Chicago, IL', technician_name: 'Marcus Vance', status: 'DISPATCHED', scheduled_at: new Date().toISOString() },
  { id: '2', order_number: 'SVC-2026-0090', customer_name: 'Apex Industrial Systems', address: '1044 Innovation Way, Chicago, IL', technician_name: 'Marcus Vance', status: 'COMPLETED', scheduled_at: new Date().toISOString() },
];

export const sampleRoutes: RouteOptimization[] = [
  { id: '1', technician_id: '1', date: new Date().toISOString(), stops: ['Central Hub Chicago', 'Customer Facility O\'Hare', 'Industrial Park Schaumburg'], total_distance_km: 64.2, est_drive_time_min: 78 },
];

export const sampleLocations: TechnicianLocation[] = [
  { technician_id: '1', name: 'Marcus Vance', latitude: 41.8781, longitude: -87.6298, heading: 85.0, speed_kmh: 42.5, status: 'EN_ROUTE', last_updated: new Date().toISOString() },
];

export const sampleVanParts: VanPart[] = [
  { id: '1', technician_id: '1', sku_id: '1', sku: 'SKU-VALVE-01', part_name: 'Brass Pressure Valve', quantity: 12, min_level: 4, max_level: 20 },
  { id: '2', technician_id: '1', sku_id: '2', sku: 'SKU-HOSE-02', part_name: 'High Pressure Hose 2m', quantity: 3, min_level: 5, max_level: 15 },
];

export const sampleHistory: ServiceHistoryItem[] = [
  { id: '1', service_order_id: '1', equipment_serial: 'SER-89021-US', equipment_model: 'Helios Edge Server 2U', customer_name: 'NexGen Data Labs', action_taken: 'Replaced fan module and updated BMC firmware', parts_replaced: ['FAN-MOD-01'], completed_at: new Date().toISOString() },
];

export const samplePMPlans: PreventiveMaintenance[] = [
  { id: '1', title: 'Quarterly Optical Recalibration', asset_name: 'Laser Sorter Unit 4', interval_days: 90, last_serviced_at: new Date().toISOString(), next_due_date: new Date(Date.now() + 90 * 86400000).toISOString(), status: 'ACTIVE' },
];

export const sampleSLAPolicies: SLAPolicy[] = [
  { id: '1', name: 'Mission Critical Platinum', priority: 'P1_CRITICAL', response_target_hours: 1, resolve_target_hours: 4, escalation_recipient: 'duty-manager@helios.local' },
  { id: '2', name: 'Standard Business SLA', priority: 'P2_HIGH', response_target_hours: 4, resolve_target_hours: 24, escalation_recipient: 'support-tier2@helios.local' },
];

export function adaptTechnician(raw: any): Technician {
  if (!raw || typeof raw !== 'object') {
    return { id: Math.random().toString(), name: 'Unknown Tech', email: '', phone: '', skills: [], status: 'AVAILABLE', current_city: '' };
  }
  return {
    id: String(raw.id || Math.random()),
    name: String(raw.name || 'Technician'),
    email: String(raw.email || ''),
    phone: String(raw.phone || ''),
    skills: Array.isArray(raw.skills) ? raw.skills : [],
    status: String(raw.status || 'AVAILABLE'),
    current_city: String(raw.current_city || raw.city || ''),
    assigned_jobs: Number(raw.assigned_jobs ?? 0),
  };
}

export function adaptServiceOrder(raw: any): ServiceOrder {
  if (!raw || typeof raw !== 'object') {
    return { id: Math.random().toString(), order_number: 'SVC-0000', customer_name: 'Unknown', address: '', status: 'DRAFT', scheduled_at: new Date().toISOString() };
  }
  return {
    id: String(raw.id || Math.random()),
    order_number: String(raw.order_number || raw.number || 'SVC-0000'),
    customer_name: String(raw.customer_name || raw.customer || 'Customer'),
    address: String(raw.address || ''),
    technician_id: raw.technician_id ? String(raw.technician_id) : undefined,
    technician_name: raw.technician_name ? String(raw.technician_name) : undefined,
    status: String(raw.status || 'PENDING'),
    scheduled_at: String(raw.scheduled_at || new Date().toISOString()),
    parts_used: Array.isArray(raw.parts_used) ? raw.parts_used : [],
    signature_url: raw.signature_url ? String(raw.signature_url) : undefined,
  };
}
